import {Component} from 'react';
import determineBondInfo from "./objects/determine_bond_info";
import { doubleToStringMonthly, standardNumberFormat} from '../../../objects/CommonUse/double_functions';
import { reformatDateToDisplay } from '../../../objects/CommonUse/reformatDateToDisplay_function';
import ConfigFile from '../../../datasets/config_file';

class InvestmentGeneralInfoCard extends Component {
    constructor(props) {
        super(props);
        this.state = {open: false, 
             selected: false,
           
        };
        this.previousCategory = "";
        this.bondFaceValue = ConfigFile.investments.bondFaceValue;
    }

reformatCouponDividendInfo(){
    this.maturityDate = null;
    if (this.props.investInfo.investmentType === "bond"){
        const bondInfo = 
            determineBondInfo(this.props.investInfo.bondInfo, this.props.startGameDate);
        if (this.props.buySell === "buy" && bondInfo.updateMaturityDate === true){
            const maturityDateObj = 
                {investShortName: this.props.investInfo.investShortName, maturityDate: bondInfo.maturityDate};
            this.props.saveMaturityDate(maturityDateObj);
        }
        this.maturityDate = bondInfo.maturityDate;
        this.couponText = bondInfo.couponText;
        this.couponRate = bondInfo.couponRate;
        this.termText = bondInfo.termText;
        if (bondInfo.faceValue){
            this.bondFaceValue = bondInfo.faceValue;
        }
    }else{
        if (this.props.investInfo.dividendInfo){
            const dividendInfo = this.props.investInfo.dividendInfo;
            if (dividendInfo.dividend === true){
                this.dividendText = "Paid " + dividendInfo.frequency;
                this.dividendRate =  (+dividendInfo.yield * 100).toFixed(1) + "%"
            }
        }else{
            this.dividendText = "None";
            this.dividendRate = "0";
        }  
    }
}   
       
render() {
        this.reformatCouponDividendInfo(); 

return <>
   
        {this.props.buySell === "buy" ? 
            <div className="">
                <b>Current Price:</b>&nbsp;&nbsp;
                    {doubleToStringMonthly(this.props.investInfo.currentPrice)}
            </div>
        :
            null
        }
        <div className="row mt-2">
            <div className="col-sm-6 mb-0">
                <b>Quantity Owned:</b>&nbsp;&nbsp;
                    {standardNumberFormat(this.props.investInfo.quantity)}
            </div>
            {this.props.investType === "bond" ?
                <div className="col-sm-6 mb-0">
                    <b>Face Value:&nbsp;</b>{doubleToStringMonthly(this.bondFaceValue)}
                </div>
            :
                null
            }
        </div>        
             
            <div className="row">
            <div className="col-sm-6">
                {this.props.buySell === "sell" ?
                    <span>
                        <div>
                            <b>Buy Date: </b>&nbsp;{reformatDateToDisplay(this.props.investInfo.transactionDate)}
                        </div>
                        <div>
                             <b>Initial Price:</b>&nbsp;&nbsp;
                                    {doubleToStringMonthly(this.props.investInfo.initialPrice)}
                        </div>
                        <div>
                            <b>Initial Purchase Amt:</b>&nbsp;
                                {doubleToStringMonthly(this.props.investInfo.totalInitialPrice)}
                        </div>
                    </span>
                 :
                    null
                }
                <div>
                    <b>Symbol:</b>&nbsp;&nbsp;{this.props.investInfo.symbol}
                </div>
                {this.props.investInfo.investmentType === "bond"   ?
                    <span>
                        <div>
                            <b>Term:</b> {this.termText}
                        </div>
                        <div>
                            <b>Coupons:</b> {this.couponText}
                        </div>
                        
                    </span>
                :
                    <div>
                            <b>Dividends: </b> {this.dividendText}
                    </div>
                }
            </div>
            <div className="col-sm-6">
                {this.props.buySell === "sell"  ?
                    <span>
                        <div><b>Buy Lot Nbr:</b>&nbsp;&nbsp;{this.props.investInfo.transNbr}</div>
                        <div>
                        <div>
                             <b>Current Price:</b>&nbsp;&nbsp;
                                    {doubleToStringMonthly(this.props.investInfo.currentPrice)}
                        </div>
                            <b>Current Amount:</b> &nbsp;&nbsp;
                                {doubleToStringMonthly(this.props.investInfo.totalCurrentPrice)}
                        </div>
                    </span>
                :
                    null
                }
                <div>
                    <b>Classification:</b>&nbsp;&nbsp;{this.props.investInfo.investClass}
                </div>
                {this.props.investInfo.investmentType === "bond"   ?
                <span>
                    <div>
                        <b>Maturity Date:</b> {reformatDateToDisplay(this.maturityDate)}
                    </div>
                    <div>
                        <b>Bond Rate:</b> {this.couponRate}
                    </div>
                </span>
                :
                    <div>
                            <b>Yield: </b> {this.dividendRate}
                    </div>
                }
            </div>
        {this.props.buySell === "buy"  ?
             <div className="ml-3 mb-0">{this.props.investInfo.overview}</div>
        :
            null
        }
        </div>

    </>
    }
}
export default InvestmentGeneralInfoCard;